import { PersonSearchSelect } from '~/pages/person/components/person-search-select';
import { WeightClassSelect } from '~/pages/weight/components/weight-class-select';
import { CategorySelect } from '~/pages/categories/components/category-select';
import { SexFilterSelect } from '~/pages/sex/components/sex-filter-select';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Grid } from '~/components/Grid/Grid';
import { querySchema } from '../query-schema';
import { ChangeEvent, useState } from 'react';
import { toIsMaleFilter } from '~/utils/sex';
import { Input } from '~/components/Input';
import { SimpleCompetitionTypeToIdMap } from '~/pages/record/list/components/query-schema';

export function RecordResultsListFilter() {
  const { setValues, setValue, values } = useFilterForm(querySchema.parse);

  const [searchLifter, setSearchLifter] = useState<[string, number] | undefined>(undefined);

  function handleCompetitionTypeChange(event: ChangeEvent<HTMLSelectElement>) {
    setValues({ competition_type: event.target.value, age_category_id: undefined });
  }

  function handleAgeCategoryChange(event: ChangeEvent<HTMLSelectElement>) {
    setValues({ age_category_id: event.target.value, weight_class_id: undefined });
  }

  function handleSexChange(event: ChangeEvent<HTMLSelectElement>) {
    setValues({ sex: event.target.value, weight_class_id: undefined });
  }

  return (
    <div
      style={{
        borderBottom: '2px solid var(--color-fg-secondary)',
        paddingBottom: 'var(--size-4)',
        marginBottom: 'var(--size-4)',
      }}
    >
      <Grid>
        <Grid.Item cols={{ sm: 6, md: 4 }}>
          <PersonSearchSelect
            onChange={person => {
              if (person) {
                const [lifter, personId] = person as [string, number];
                setValue('person', personId.toString());
                setSearchLifter([lifter, personId]);
              } else {
                setSearchLifter(undefined);
                setValue('person', undefined);
              }
            }}
            placeholder="Sök efter lyftare..."
            value={searchLifter}
            name="person"
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 4 }}>
          <Input.Select
            defaultValue={values.competition_type}
            onChange={handleCompetitionTypeChange}
            options={[
              ['Klassisk', 'classic'],
              ['Utrustad', 'equipped'],
              ['IFN', 'ifn'],
              ['Para', 'para'],
            ]}
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 4 }}>
          <CategorySelect
            query={{ competition_types: SimpleCompetitionTypeToIdMap[values.competition_type], has_records: true }}
            defaultValue={values.age_category_id}
            onChange={handleAgeCategoryChange}
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 2 }}>
          <SexFilterSelect onChange={event => handleSexChange(event)} defaultValue={values.sex} />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 2 }}>
          <WeightClassSelect
            query={{
              competition_types: SimpleCompetitionTypeToIdMap[values.competition_type],
              age_category: values.age_category_id ?? undefined,
              is_male: toIsMaleFilter(values.sex),
            }}
            onChange={event => setValue('weight_class_id', event.target.value)}
            key={`${values.sex}-${values.weight_class_id}`}
            defaultValue={values.weight_class_id}
            name="weight_class_id"
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 4 }}>
          <Input.Field
            onChange={event => setValue('from_date', event.target.value)}
            defaultValue={values.from_date}
            type="date"
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 4 }}>
          <Input.Field
            onChange={event => setValue('to_date', event.target.value)}
            defaultValue={values.to_date}
            type="date"
          />
        </Grid.Item>
      </Grid>
    </div>
  );
}
